// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"blog-carousel_cardContainer__KNNKH"};